import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    BaseEntitiesResponse,
    SystemCredentialInfo, CredentialsCheckerMetadata, 
    BaseDataResponse, CredentialExternalInfo, CreateCredentialsParams, SystemCredentialParams, GenericListEntity
} from '@base/entities/BaseEntities';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { BaseEndpoint } from '@base/endpoint/BaseEndpoint';
import { DataLoadOptions } from '@base/datalayer/DataLoadOptions';

@Injectable()
export class SystemCredentialsEndpoint extends BaseEndpoint {
    //Constructor
    constructor(api: APIGatewayService) {
        super('SystemCredentials', api);
    }

    public ListSystemCredentials(Params: SystemCredentialParams, options: DataLoadOptions)
        : Observable<BaseEntitiesResponse<SystemCredentialInfo>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListSystemCredentials', Params, options?.GetLoadOptions());
    }

    public ListCredentialsForCreations(params: SystemCredentialParams): Observable<BaseEntitiesResponse<CredentialExternalInfo>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListCredentialsForCreations', params);
    }

    public CreateCredentials(params: CreateCredentialsParams) {
        return this.api.ExecutePostAction(this.ControllerName, 'CreateCredentials', params);
    }

    public SendWelcomeUserMessage(params: CreateCredentialsParams) {
        return this.api.ExecutePostAction(this.ControllerName, 'SendWelcomeUserMessage', params);
    }

    public GetAdditionalInfoMetadata(): Observable<BaseDataResponse<CredentialsCheckerMetadata>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetAdditionalInfoMetadata');
    }

    public GetAvailableCredentialFilters(): Observable<BaseEntitiesResponse<GenericListEntity>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetAvailableCredentialFilters', { });
    }
}